module.exports = __webpack_public_path__ + "img/wfzs-nav.414c182.svg";